import React from 'react'
import { Checkbox } from '@mui/material'

const CheckboxCell = cellData => {
  const { api, id, field, value, disabled } = cellData
  return (
    <Checkbox
      checked={value}
      disabled={disabled}
      sx={{
        '&.Mui-disabled.Mui-checked': {
          color: '#4CAF50',
          opacity: '50%',
        },
      }}
      onChange={e => {
        const row = api.getRow(id)
        api.updateRows([{ ...row, [field]: e.target.checked }])
      }}
    />
  )
}

export default CheckboxCell
